export default "__VITE_ASSET__CjQUsp6V__"